export default function departmentsDirective() {
  return {
    template: require('./departments.html'),
    controller: 'DepartmentsController',
    controllerAs: 'departmentsVM',
    scope: {
      customerId: '<',
      departments: '=',
      canAdd: '=',
      isIt: '='
    },
    bindToController: true,
    replace: true,
  };
}
